/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@pwc/pwc-deals-ui';
import { useSelector } from 'react-redux';
import { getUserSettingsSelector } from 'common/redux/userSettings/userSettingsSlice';
import { isUSTerritory } from 'common/helpers/projectInitUtil';
import {
  EMPTY_FAVOURITE_HEADING,
  US_EMPTY_FAVOURITE_HEADING,
} from 'common/constants/General';
import './EmptyFavouriteCard.scss';

const EmptyFavouriteCard = () => {
  const userSettings = useSelector(getUserSettingsSelector);
  const isDarkMode = userSettings.settings.darkMode;
  const { t } = useTranslation();
  return (
    <div className="empty-favourite-card">
      <div>
        <Icon
          name={isDarkMode ? 'star-dark' : 'star-light'}
          width={24}
          className="outline icon-grey"
        />
      </div>
      <div>
        <div className="heading">
          {isUSTerritory
            ? t(US_EMPTY_FAVOURITE_HEADING)
            : t(EMPTY_FAVOURITE_HEADING)}
        </div>
        <div className="subHeading">{t('projectStarIconMessage')}</div>
      </div>
    </div>
  );
};

export default EmptyFavouriteCard;
